import ProductEntity from "@modules/products/entities/ProductEntity";

import { ProductVariantSdkDto } from "../types";
import { mapProductImageToSdkDto } from "./mapProductImageToSdkDto";
import { mapProductPriceToSdkDto } from "./mapProductPriceToSdkDto";

export function mapProductVariantToSdkDto(
    variant: ProductEntity["variants"][0]
): ProductVariantSdkDto {
    return {
        id: variant.id,
        title: variant.title,
        price: mapProductPriceToSdkDto(variant.price),
        compareAtPrice: variant.compareAtPrice
            ? mapProductPriceToSdkDto(variant.compareAtPrice)
            : null,
        quantityAvailable: variant.quantityAvailable,
        currentlyNotInStock: variant.currentlyNotInStock,
        image: variant.image ? mapProductImageToSdkDto(variant.image) : null,
    };
}
